import styled from "styled-components";

const SearchSubmitButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 60px;
  min-height: 44px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: #6940db;
  color: #fff;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) { background: #7955f0; }
  &:focus-visible { outline: 2px solid var(--user-accent, #6940db); outline-offset: 2px; }
  &:disabled { opacity: .6; cursor: default; }
`;

export default SearchSubmitButton;
